import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

export function useWhitelabelSignupCopiesEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.SquadTechnicalSolutionsWhitelabelSignupCopies,
    false
  );

  return Boolean(isEnabled);
}
